export const defaultTaskColor = "#2368b7";
export const taskColor = (color) => /^#[0-9a-f]{6}$/i.test(color || "") ? color : defaultTaskColor;
export const taskColorStyle = (color) => ({
  "--visit-bg": `${taskColor(color)}18`,
  "--visit-border": `${taskColor(color)}55`,
  "--visit-ink": taskColor(color),
});
